import { forwardRef } from 'react';
import "./Admin.css"
const AdminSwitch = forwardRef(
    ({ name, checked, onChange, id, disabled, placeHolder, ...rest }, ref) => {
        return (
            <div className="admin-switch-wrapper d-inline-block position-relative">
                <label className="admin-switch m-0">
                    <input
                        name={name}
                        type="checkbox"
                        checked={checked}
                        id={id}
                        data-test-id={id || name}
                        ref={ref}
                        onChange={(e) => onChange(e, id)}
                        className="r-input opacity-0"
                        disabled={disabled}
                        {...rest}
                    />
                    <span
                        className={`admin-slider position-absolute admin-round ${disabled ? "disabled-cursor" : ""
                            }`}
                    ></span>
                    <p
                        className={`indicator-on-off theme-button-text-color ${ placeHolder ? "on" : checked ? "on" : "off"
                            }`}
                    >
                        {placeHolder ? '' : checked ? "ON" : "OFF"}
                    </p>
                </label>

                {/* Spinner added here */}
                {disabled && (
                    <div className="spinner-overlay">
                        <div className="spinner"></div>
                    </div>
                )}
            </div>
        );
    }
);


export default AdminSwitch;
